$(document).ready(function () {
  // obecne
  var bodyWidth = window.innerWidth;

  // události při resize okna
  $(window).on('resize', function () {
    // osetreni, zda se velikost zmenila
    if (bodyWidth !== window.innerWidth) {
      // nastavíme novou šířku
      bodyWidth = window.innerWidth;
      // zresetuj menu
      resetMenu();
    }
  });

  // mobilní menu
  function switchMenu() {
    // označíme zda je menu zavřeno či nikoliv
    if ($('.js-menu').hasClass('is-open')) {
      $('.js-menu').removeClass('is-open');
    } else {
      $('.js-menu').addClass('is-open');
    }
  }
  // při změně rozlišení resetujeme menu
  function resetMenu() {
    $('.js-menu').removeClass('is-open');
  }
  // spouštěč
  $('.js-menu-toggle').on('click', function () {
    switchMenu();

    return false;
  });

  if (bodyWidth > 768) {
    $('.js-search-toggle').on('mouseenter', function () {
      $(this).find("input[type='search']").show('slide');
      $(this).find("input[type='search']").focus();
    });

    $(".js-search-toggle input[type='search']").on('focusout', function () {
      $(this).hide('slide');
    });
  }

  // -------------------------------------
  // ScrollTo (click on link)
  // -------------------------------------
  $("a[href^='#']").on('click', function () {
    if ($(this).hasClass('js-no-scrollto')) {
      return false;
    }
    var thisHref = $(this).attr('href');

    $.scrollTo(thisHref, 800, {
      offset: -100,
      axis: 'y',
    });

    return false;
  });

  // ======================================
  // SITMP - Dvorak
  // ======================================

  // Ajax login
  // Poslouchame jak to dopadlo :)
  $(document).on('lwa_login', function (event, data, form) {
    if (data.result === false) {
      // Smazeme hlasky
      // Nedalo se to prebit v PHP
      $('.lwa-status').remove();
      // Oznacime inputs .error
      $('.js-handle-form-login')
        .find('input[type="text"], input[type="password"]')
        .addClass('error');
    }
  });

  $('.js-handle-form-login').on(
    'keyup',
    'input[type="text"], input[type="password"]',
    function () {
      $('.js-handle-form-login')
        .find('input[type="text"], input[type="password"]')
        .removeClass('error');
    }
  );

  // Zobrazit / skryt filtr
  $('.js-handle-toggle-filter').on('click', function (e) {
    $('#js-filter-top').toggleClass('is-visible');
    $('#js-filter-bottom').toggleClass('is-visible');
    e.preventDefault();
  });

  function checkFilterItems() {
    var show = 0;
    $('#js-filter-bottom')
      .find('input[type="checkbox"]')
      .each(function () {
        if ($(this).prop('checked') == true) {
          show++;
        }
      });

    $('#js-filter-bottom')
      .find('select')
      .each(function () {
        if (this.selectedIndex != 0) {
          show++;
        }
      });

    if (show > 0) {
      $('.js-handle-reset-filter').fadeIn(200);
    } else {
      $('.js-handle-reset-filter').fadeOut(200);
    }
  }

  // Zobrazit / skryt reset filtru
  $('#js-filter-bottom').on('click', function () {
    checkFilterItems();
  });

  checkFilterItems();
});

//# sourceMappingURL=scripts.js.map
